import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps } from "vue"


export default /*#__PURE__*/_defineComponent({
  props: {
  label: {
    type: String,
    default: undefined,
  },
  color: {
    type: String,
    default: 'primary',
  },
  slideEffectColor: {
    type: String,
    default: undefined,
  },
  disable: Boolean,
  tooltip: {
    type: String,
    default: undefined,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_c_spinner = _resolveComponent("c-spinner")!
  const _component_c_slide_effect = _resolveComponent("c-slide-effect")!
  const _component_c_tooltip = _resolveComponent("c-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, _mergeProps(_ctx.$inri.button, {
    color: __props.color,
    label: __props.label,
    disable: __props.disable,
    class: "group overflow-hidden"
  }), {
    loading: _withCtx(() => [
      _createVNode(_component_c_spinner, {
        size: "28",
        "parent-color": __props.color
      }, null, 8, ["parent-color"])
    ]),
    default: _withCtx(() => [
      (!__props.disable)
        ? (_openBlock(), _createBlock(_component_c_slide_effect, {
            key: 0,
            "parent-color": __props.color,
            "slide-effect-color": __props.slideEffectColor,
            "slide-right": "",
            class: "-z-1"
          }, null, 8, ["parent-color", "slide-effect-color"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default"),
      (__props.tooltip)
        ? (_openBlock(), _createBlock(_component_c_tooltip, { key: 1 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.tooltip), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 16, ["color", "label", "disable"]))
}
}

})